<template>
    <div id="toolbar">
        <div id="address-search">
            <autocomplete
                ref="search"
                url="http://maps.co.mecklenburg.nc.us/rest/v5/ws_geo_ubersearch.php"
                param="query"
                anchor="address"
                label="Test"
                placeholder="Search Address"
                :min="6"
                :on-select="getData">
            </autocomplete>
        </div>
        <button  id="printButton" @click="printMap()">Print</button>
    </div>
</template>

<script>
    export default {
         methods: {
            getData(obj){
                this.$store.commit("latlng", [obj.lat,obj.lng]);
                this.$store.commit("selPID", obj.pid);
                this.$store.commit("matID", obj.id);
                this.$store.commit("selAddress", obj.address);
            },
            printMap(){
                var matID = this.$store.state.matID;
                var latLng = this.$store.state.latlng;
                var lat = latLng[0];
                var lng = latLng[1];
                //window.open("printpage.html?matID=" + matID,"_blank");
                window.open("printpage.html?matID=" + matID + "&lat=" + lat + "&lng=" + lng,"_blank");
            }
        }
    }
</script>

<style scoped>
    #toolbar{
        margin-top:5px;
        margin-left:0px;
        margin-bottom: 5px;
        width:100%;
    }
    
    #address-search {
        margin-left: 10px;
        padding: 5px;
        z-index: 1000;
        float: left;
    }
    #printButton{
        padding:2px 10px; 
        margin-right:10px; 
        background-color:#E6E6E6;
        color:#000;
        border-radius: 25px;
        float: right;
    }
</style>